import React, { ReactElement } from 'react';
import { VIEW_GRIEVANCE_ROUTE } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../../utils/routeUtility';

const ViewGrievance = ({ match, location }: any): ReactElement => {
  const nextDefaultPage = getMappedRoute(location?.pathname, VIEW_GRIEVANCE_ROUTE) || VIEW_GRIEVANCE_ROUTE[0].routeName;

  return (
    <NestedRoute
      match={match}
      defaultPage={nextDefaultPage}
      nestedNav={VIEW_GRIEVANCE_ROUTE}
    />
  );
};
export default ViewGrievance;
